// frontend/src/components/EdaPrepare/EdaPrepareAnalysis.tsx

import React, { useEffect } from 'react';
import { useEdaPrepare } from '../../hooks/useEdaPrepare';
import { useAuth } from '../../contexts/AuthContext';
import { EdaPrepareSelector } from './EdaPrepareSelector';
import { EdaPrepareStats } from './EdaPrepareStats';
import { EdaPrepareSummary } from './EdaPrepareSummary';
import { EdaPrepareWarnings } from './EdaPrepareWarnings';
import { EdaPrepareTransformations } from './EdaPrepareTransformations';
import './EdaPrepareAnalysis.css';

export const EdaPrepareAnalysis: React.FC = () => {
  const { selectedTraceId, selectedDataset: authDatasetName } = useAuth();
  
  const {
    snapshots,
    selectedSnapshot,
    analysis,
    loading,
    error,
    selectSnapshot,
    listSnapshots,
  } = useEdaPrepare();

  useEffect(() => {
    listSnapshots();
  }, [listSnapshots]);

  if (loading && !analysis) {
    return (
      <div className="eda-prepare-container">
        <div className="loading-state">🔬 Carregando análise EDA Prepare...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="eda-prepare-container">
        <div className="error-state">❌ {error}</div>
      </div>
    );
  }

  // Se há trace selecionado globalmente mas a análise ainda não chegou
  if (selectedTraceId && !analysis) {
    return (
      <div className="eda-prepare-container">
        <div className="loading-state">⏳ Carregando dados do dataset selecionado...</div>
      </div>
    );
  }

  return (
    <div className="eda-prepare-container">
      <div className="eda-prepare-header">
        <h1>🧹 EDA Prepare</h1>
        <p className="subtitle">Análise de preparação de dados para Machine Learning</p>

        {selectedSnapshot?.trace_id && (
          <div className="trace-badge">
            <span className="label">Trace ID:</span>
            <code>{selectedSnapshot.trace_id}</code>
          </div>
        )}
      </div>

      {/* Só exibe o seletor se NÃO houver trace selecionado globalmente */}
      {!selectedTraceId ? (
        <EdaPrepareSelector
          snapshots={snapshots}
          selectedSnapshot={selectedSnapshot}
          onSelect={selectSnapshot}
          loading={loading}
        />
      ) : (
        <div style={{
          background: 'rgba(79, 195, 247, 0.1)',
          border: '1px solid #4fc3f7',
          borderRadius: '8px',
          padding: '12px 16px',
          marginBottom: '24px',
          color: '#4fc3f7',
        }}>
          <span>
            Dataset em foco: <strong>{analysis?.dataset_name || selectedSnapshot?.dataset_name || authDatasetName || 'Carregando...'}</strong>
          </span>
          <div style={{ fontSize: '11px', marginTop: '4px', color: '#8899aa' }}>
            Para alterar o dataset, acesse a tela "Meus Dados".
          </div>
        </div>
      )}

      {analysis && (
        <>
          <EdaPrepareStats analysis={analysis} />
          <EdaPrepareSummary analysis={analysis} />
          <EdaPrepareWarnings warnings={analysis.warnings} />
          <EdaPrepareTransformations analysis={analysis} />
        </>
      )}
    </div>
  );
};

export default EdaPrepareAnalysis;